import type { ApiTypingsLookup } from "@/api";

// Returned by a handler to decline a request and let it reach the real
// backend, e.g. a handler that only has canned data for some envs. Dispatch
// sites treat it the same as an unregistered read kind. Without it, registering
// a handler makes a kind fake for every preview env with no way to opt out.
export const PREVIEW_PASSTHROUGH = Symbol("PREVIEW_PASSTHROUGH");
export type PreviewPassthrough = typeof PREVIEW_PASSTHROUGH;

export type PreviewHandler<K extends keyof ApiTypingsLookup> = (
  params: ApiTypingsLookup[K]["request"],
) => ApiTypingsLookup[K]["response"] | PreviewPassthrough;

type UntypedHandler = (params: unknown) => unknown;

const handlers = new Map<string, UntypedHandler>();

export function registerPreviewHandler<K extends keyof ApiTypingsLookup>(
  kind: K,
  handler: PreviewHandler<K>,
): void {
  handlers.set(kind as string, handler as UntypedHandler);
}

export function getPreviewHandler(kind: string): UntypedHandler | undefined {
  return handlers.get(kind);
}

export function __clearPreviewHandlers(): void {
  handlers.clear();
}
